import { render, staticRenderFns } from "./page-analysis.vue?vue&type=template&id=f217f84e&scoped=true"
import script from "./page-analysis.vue?vue&type=script&lang=js"
export * from "./page-analysis.vue?vue&type=script&lang=js"
import style0 from "./page-analysis.vue?vue&type=style&index=0&id=f217f84e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f217f84e",
  null
  
)

export default component.exports